import { render, staticRenderFns } from "./404Page.vue?vue&type=template&id=4c7a8a1c&scoped=true"
import script from "./404Page.vue?vue&type=script&lang=js"
export * from "./404Page.vue?vue&type=script&lang=js"
import style0 from "./404Page.vue?vue&type=style&index=0&id=4c7a8a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7a8a1c",
  null
  
)

export default component.exports